/*
 * Product page: complementary products as cards (same markup/CSS as the cart drawer).
 * Fetches sections/cart-complementary.liquid through the Product Recommendations API.
 */
if ( ! customElements.get('product-complementary') ) {

	class ProductComplementary extends HTMLElement {

		connectedCallback(){
			this.list = this.querySelector('[data-cart-comp-list]');
			if ( ! this.list ) return;
			this.limit = parseInt(this.dataset.limit) || 4;

			this.addEventListener('submit', e => {
				const form = e.target.closest('[data-cart-comp-form]');
				if ( form ) { e.preventDefault(); this.addToCart(form); }
			});

			this.load();
		}

		fetchItems(intent){
			const url = `${this.dataset.url}?section_id=${this.dataset.section}&product_id=${this.dataset.productId}&limit=${this.limit}&intent=${intent}`;
			return fetch(url)
				.then(response => response.ok ? response.text() : '')
				.then(text => Array.from(new DOMParser().parseFromString(text, 'text/html').querySelectorAll('.cart-comp__item')))
				.catch(() => []);
		}

		async load(){
			let items = await this.fetchItems('complementary');
			if ( items.length === 0 && this.dataset.fallback === 'true' ) items = await this.fetchItems('related');
			items = items.filter(item => item.dataset.productId !== this.dataset.productId).slice(0, this.limit);
			this.list.replaceChildren(...items);
			this.hidden = items.length === 0;
		}

		addToCart(form){
			const item = form.closest('.cart-comp__item');
			const button = form.querySelector('button[type="submit"]');
			const error = item.querySelector('[data-cart-comp-error]');
			const variantId = form.querySelector('[name="id"]').value;

			error.textContent = '';
			button.disabled = true;
			item.classList.add('cart-comp__item--working');

			fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
				body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
			})
				.then(response => response.json().then(data => ({ ok: response.ok, data })))
				.then(({ ok, data }) => {
					if ( ! ok ) {
						error.textContent = typeof data.description === 'string' ? data.description : ( data.message || '' );
						return;
					}
					if ( typeof window.refreshCart === 'function' ) {
						window.refreshCart(); // updates the drawer and opens it
					} else {
						document.location.href = KROWN.settings.routes.cart_url;
					}
					if ( window.KROWN && KROWN.functions && KROWN.functions.eventDispatcher ) {
						KROWN.functions.eventDispatcher('krown:cart:add', { productForm: form, variantId });
					}
				})
				.catch(e => console.log(e))
				.finally(() => {
					button.disabled = false;
					item.classList.remove('cart-comp__item--working');
				});
		}
	}

	customElements.define('product-complementary', ProductComplementary);
}
